import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-visit-time',
  templateUrl: './visit-time.component.html',
  styleUrls: ['./visit-time.component.scss'],
})
export class VisitTimeComponent implements OnInit {
  @Input() visit: any = {};
  @Input() day: any = [];
  @Input() dayNumber: number;
  @Input() visitIndex: number;
  showItemList = false;
  time: string;
  location: string;
  hours: number;
  minutes: number;
  singleModule: any = null;
  constructor(private router: Router) {}

  ngOnInit(): void {
    if (this.visit.visitTypeTab === 2) {
      if (!this.visit.plannedStartTime) {
        this.time = '';
      } else if (!this.visit.plannedEndTime) {
        this.time = this.visit.plannedStartTime;
      } else {
        this.time = `${this.visit?.plannedStartTime} - ${this.visit?.plannedEndTime}`;
      }
    } else {
      this.time = this.visit.inspectionTime;
    }

    this.location =
      this.visit.visitTypeTab === 2
        ? this.visit?.locationName
        : this.visit?.location;
    if (this.visit.visitDurationMinutes % 60 === 0) {
      this.hours = this.visit.visitDurationMinutes / 60;
      this.minutes = 0;
    } else {
      this.hours = Math.floor(this.visit.visitDurationMinutes / 60);
      this.minutes = this.visit.visitDurationMinutes % 60;
    }

    if (
      this.visit.modules &&
      this.visit.modules.length > 0 &&
      this.visit.visitType === 'J'
    ) {
      const firstModuleName = this.visit.modules[0].moduleName;
      const allSameModuleName = this.visit.modules.every(
        (module) => module.moduleName === firstModuleName
      );

      if (allSameModuleName) {
        const totalCnt = this.visit.modules.reduce(
          (sum, module) => sum + module.cnt,
          0
        );
        this.singleModule = {
          moduleName: firstModuleName,
          cnt: totalCnt,
        };
      }
    }
  }

  navigateToDetailPage(visit: any) {
    if (visit.visitTypeTab === 1) {
      this.router.navigate(['visitdetails', visit?.id]);
    } else if (visit.visitTypeTab === 2 && !visit.nonVisit) {
      this.router.navigate(['visitday', visit?.planningDate, this.dayNumber], {
        fragment: visit?.visitId,
        queryParams: { openVisitId: visit?.visitId },
      });
    }
  }
}
